module.exports = __webpack_public_path__ + "static/media/open-sans-v17-latin-ext_latin-300.f3f15938.woff2";